import Partners from './Partners.jsx';
export default Partners;
